import axios from '../../../../api/axios';
export const initialState = {
  isLoaded: false,
  users: null,
  search: {},
  page: 1,
};
export const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'LOADING':
      return { ...state, isLoaded: false };
    case 'LOADED':
      return { ...state, isLoaded: true };
    case 'USERS':
      return { ...state, isLoaded: true, users: payload };
    case 'USER':
      let user = state.users.docs.find((u) => u._id === payload._id);
      user.status = payload.status;
      return { ...state };
    case 'CHANGE_PAGE':
      return { ...state, page: payload };
    case 'CHANGE_FIELDS':
      return {
        ...state,
        search: {
          ...state.search,
          [payload.name]: payload.value,
        },
      };
    case 'SELECT_ROLE':
      const { name, checked } = payload;
      if (name === 'legal') {
        if (checked) {
          return {
            ...state,
            search: {
              ...state.search,
              legal: true,
            },
          };
        } else {
          delete state.search.legal;
          return { ...state };
        }
      }
      if (checked) {
        return {
          ...state,
          search: {
            ...state.search,
            role: Array.isArray(state.search.role)
              ? [...state.search.role, name]
              : [name],
          },
        };
      } else {
        if (state.search.role && state.search.role.length === 1) {
          delete state.search.role;
          return { ...state };
        } else
          return {
            ...state,
            search: {
              ...state.search,
              role: state.search.role.filter((r) => r !== name),
            },
          };
      }
    default:
      return { ...state };
  }
};
export const actions = {
  fetchingUsers: async (page = 1, limit, query) => {
    try {
      const { data: users } = await axios.post(`/api/v1/admin/users/listAllUsers`, {
        page,
        limit,
        query,
      });
      return users;
    } catch (error) {
      return new Error(error);
    }
  },
};
